
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import moment from 'moment';
//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CATALOG_LOAD,
	CATALOG_INITIAL,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientGET } from 'Core/data/RestApi';
import {
    catalogLoadResult,
	catalogLoadign,
	catalogInitialResult,
} from 'Redux/actions';


export function* loadCatalogs(){

}

export function* loadInitialCatalogs(){
    
}


function* watchMethods() {
    yield takeEvery(CATALOG_LOAD, loadCatalogs);
    yield takeEvery(CATALOG_INITIAL, loadInitialCatalogs);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}